import mitt from "mitt";

type Events = {
    "Browser::activestatechange": boolean;
};

export const emitter = mitt<Events>();
